export default __webpack_public_path__ + "static/media/zoro.ac2497be.png";